define("shared/utils/constants/linkinbio-feed-types", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  var FeedTypes = /*#__PURE__*/function (FeedTypes) {
    FeedTypes["Instagram"] = "igFeed";
    FeedTypes["Tiktok"] = "ttFeed";
    return FeedTypes;
  }(FeedTypes || {});
  var _default = _exports.default = FeedTypes;
});